/**
 * Client <-> server message types for KNGDM.IO.
 *
 * See `docs/04_NETWORKING_PROTOCOL.md`. These types exist now, before any
 * networking, on purpose: the in-process bot in Phase 3 submits intents through
 * this exact shape, so the multiplayer phase adds a transport and changes
 * nothing in `server/src/game`.
 *
 * The principle, restated because it is easy to erode: **clients send intents,
 * the server sends state.** Never the reverse. A client never computes an
 * outcome and tells the server what happened.
 */
export const RESOURCE_TYPES = [
    "food",
    "timber",
    "ore",
    "gold",
    "aether",
];
/**
 * The four resources terrain yields, excluding Aether.
 *
 * Aether comes only from special hexes, and the generator deliberately keeps
 * those away from spawns — so any calculation about how good a *biome* or a
 * region is must iterate this, not `RESOURCE_TYPES`. Iterating all five puts a
 * permanent zero into the fold, which silently flattens exactly the kind of
 * "does this spawn have all the resources" term it looks harmless in.
 *
 * That is not hypothetical: it broke spawn placement the first time Aether was
 * added, and `mapgen.test.ts` caught it by finding an ore-less opening.
 */
export const TERRAIN_RESOURCE_TYPES = [
    "food",
    "timber",
    "ore",
    "gold",
];
export const BIOMES = [
    "plains",
    "forest",
    "hills",
    "mountains",
    "desert",
    "tundra",
];
export const SPECIAL_HEXES = ["ruins", "geyser", "crystalVein"];
export const GOD_TOOLS = ["terraform", "fortify", "calm", "provoke"];
/**
 * Intent types the simulation actually handles today. Anything outside this set
 * is rejected by the intent handler rather than silently ignored, so a
 * half-implemented feature fails loudly during development.
 */
export const IMPLEMENTED_INTENT_TYPES = [
    "claimHex",
    "surge",
    "clearSurge",
    "setWorkerTroopSplit",
    "placeBuilding",
    "useGodTool",
];
//# sourceMappingURL=messages.js.map